<template>
  <div class="new-people-activity-dialog-wrap">
    <el-dialog
      v-model="innerVisible"
      top="50%"
      custom-class="new-people-activity-dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <div class="dialog-content">
          <div class="title" :class="{ expire: isExpire }">
            {{ isExpire ? "优惠券过期通知" : "恭喜你获得" }}
          </div>
          <div v-if="isExpire" class="expire-coupon-desc">
            <div class="desc-text">
              您的首单优惠券将在
              <div class="expire-day">
                {{ minimumExpireDay ? minimumExpireDay + 1 : "今" }}天
              </div>
              后过期
            </div>
            <div class="desc-tips">优惠力度很大请别错过哦～</div>
          </div>
          <div v-else class="get-coupon-desc">
            新人
            <div class="important-text">首单优惠券</div>
            权益{{ couponList.length > 1 ? "礼包" : "" }}
          </div>

          <div class="coupon-scroll">
            <div class="coupon-list">
              <coupon-item
                v-for="item in couponList"
                :key="item.coupon_id"
                :coupon="item"
                @showCouponDescDialog="showCouponDescDialog"
              ></coupon-item>
            </div>
          </div>

          <div class="dialog-footer">
            <div class="use-btn" @click="gotoDestination">立即使用</div>
            <div class="my-coupon-text">
              已存入<span class="link" @click="gotoMyCoupon">我的优惠券</span>
            </div>
          </div>
        </div>
        <div class="close-btn" @click="close">
          <img src="../../../../assets/imgs/coupon/modal-close.png" />
        </div>
      </div>
    </el-dialog>

    <coupon-desc-dialog :show.sync="couponDescDialog.show" :coupon="couponDescDialog.coupon"></coupon-desc-dialog>

  </div>
</template>

<script>
import dateUtils from '../../../../libs/date-util';
import CouponItem from './components/coupon-item.vue';
import CouponDescDialog from '../../../user/user-children/components/coupon-desc-dialog.vue';

export default {
  components: {
    CouponItem,
    CouponDescDialog,
  },
  props: {
    // 是否打开
    visible: {
      type: Boolean,
      default: false,
    },
    couponList: {
      type: Array,
      default: () => [],
    },
    activityInfo: {
      type: Object,
      default: () => ({}),
    },
    // 是否是优惠券过期提醒
    isExpire: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      couponDescDialog: {
        show: false,
        coupon: {},
      },
    };
  },
  computed: {
    // 最小的优惠券过期时间
    minimumExpireDay() {
      if (!this.couponList || !this.couponList.length) return 0;

      const nowDate = new Date();

      let minimumExpireDay = dateUtils.getDateDayDiff(
        nowDate,
        this.couponList[0].end_date,
      );
      this.couponList.forEach((item) => {
        const expireDay = dateUtils.getDateDayDiff(nowDate, item.end_date);
        if (expireDay < minimumExpireDay) {
          minimumExpireDay = expireDay;
        }
      });
      return minimumExpireDay;
    },
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.close();
        }
      },
    },
  },
  watch: {},

  methods: {
    // 关闭
    close() {
      this.$emit('close', false);
    },
    showCouponDescDialog(coupon) {
      this.couponDescDialog.show = true;
      this.couponDescDialog.coupon = coupon;
    },
    gotoDestination() {
      this.close();
      this.$router.push({ path: '/countries' });
    },
    gotoMyCoupon() {
      this.close();
      this.$router.push({ name: 'coupon' });
    },
  },
};
</script>

<style lang="less" scoped>
.new-people-activity-dialog-wrap{
  /deep/ .new-people-activity-dialog {
    transform: translate(-50%,-50%);
    width: 440px;
    // box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.2);
    box-shadow: none;
	  background: transparent;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .dialog-body {
    text-align: left;
    display: inline-block;
    vertical-align: middle;
    width: 440px;
    border-radius: 12px;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    background: #fff9ee;
    line-height: 1;
    .dialog-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        width: 224px;
        height: 58px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 28px;
        font-weight: 600;
        background: url(https://o.666visa.cn/static/ssqpeer/homepage/new-people-dialog/coupon-title-1.png)
          no-repeat center / 100% 100%;
        &.expire {
          width: 280px;
          background: url(https://o.666visa.cn/static/ssqpeer/homepage/new-people-dialog/coupon-title-2.png)
            no-repeat center / 100% 100%;
        }
      }
      .expire-coupon-desc {
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .desc-text {
          color: #2f333d;
          font-size: 26px;
          font-weight: 600;
          line-height: 37px;
          .expire-day {
            margin: 0 4px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0 8px;
            height: 32px;
            background: #ff5550;
            border-radius: 4px;
            color: #fff;
            font-size: 26px;
          }
        }
        .desc-tips {
          margin-top: 8px;
          color: #717785;
          font-size: 16px;
        }
      }
      .get-coupon-desc {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 24px;
        color: #2f333d;
        font-size: 32px;
        font-weight: 600;
        .important-text {
          color: #ff5550;
        }
      }
      .coupon-scroll {
        margin-top: 24px;
        height: 340px;
        width: 100%;
        overflow: auto;
        .coupon-list {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-bottom: 100px;
        }
      }

      .dialog-footer {
        margin-top: -100px;
        width: 100%;
        height: 172px;
        background: url(https://o.666visa.cn/static/ssqpeer/homepage/new-people-dialog/new-people-coupon-dialog-footer.png)
          no-repeat center / 100% 100%;
        padding-top: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        z-index: 10;
        .use-btn {
          width: 180px;
          height: 40px;
          background: linear-gradient(
            102deg,
            #ffe39d 0%,
            #ffd183 100%,
            #ffd183 100%
          );
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #8e2c00;
          font-size: 18px;
          font-weight: 600;
        }
        .my-coupon-text {
          margin-top: 12px;
          color: #fff;
          font-size: 16px;
          .link {
            text-decoration: underline;
          }
        }
      }
    }
    .close-btn {
      position: absolute;
      bottom: -81px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      justify-content: center;
      font-size: 0;
      cursor: pointer;
      img {
        width: 36px;
        height: 36px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/index/components/new-people-activity-dialog/new-people-activity-dialog.vue